<div class="container">
    <form class="row" [formGroup]="bannerForm"
        (ngSubmit)="onSubmit(bannerForm)">
        <div class="col-md-8 offset-md-2 p-4 mt-2">
            <div class="border shadow p-3">

                <div class="my-2 row">
                    <label class="col-form-label">Web Banner Image </label>
                    <div class="d-flex">
                        <input type="text" class="form-control"
                            placeholder="URL" formControlName="web_banner">
                        <a [href]="bannerForm.value.web_banner"
                            target="_blank"><img class="ms-1" height="40"
                                [src]="bannerForm.value.web_banner"></a>
                        <button class="btn btn-primary ms-1" type="button"
                            (click)="openUploadModal('web_banner')"><i
                                class="fas fa-cloud-upload-alt"></i></button>
                    </div>
                    <small class="text-info">Image ratio 1:1 preferred</small>
                </div>

                <div class="my-2 row">
                    <label class="col-form-label">Mobile Banner Image</label>
                    <div class="d-flex">
                        <input type="text" class="form-control"
                            placeholder="URL" formControlName="mob_banner">
                        <a [href]="bannerForm.value.mob_banner"
                            target="_blank"><img class="ms-1" height="40"
                                [src]="bannerForm.value.mob_banner"></a>
                        <button class="btn btn-primary ms-1" type="button"
                            (click)="openUploadModal('mob_banner')"><i
                                class="fas fa-cloud-upload-alt"></i></button>
                    </div>
                    <small class="text-info">Image ratio 1:1 preferred</small>
                </div>

                <div class="my-2 row">
                    <div class="col-md-12">
                        <label class="col-form-label">Banner Link</label>
                        <input type="text" class="form-control"
                            placeholder="Banner Url"
                            formControlName="banner_link">
                    </div>
                </div>

                <div class="my-2 row">
                    <div class="col-md-12">
                        <button class="btn btn-info float-end mt-2">
                            <i
                                [ngClass]="{'fa fa-pulse fa-spin fa-spinner': isUpdating,'bx bx-save': !isUpdating}"></i>
                            Save Changes</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>